import dayjs from "dayjs"

// Converts null to undefined
const convertDate = (connectDate: string | null) => (connectDate ? connectDate : undefined)

// Do nothing with the from date
export const convertFromDate = convertDate

// Add one day to the "to"-Date for an "inclusive" filter
export const convertToDate = (connectDate: string | null) => (connectDate ? adjustToDate(connectDate) : undefined)

// Adds one day to the date
export const adjustToDate = (connectDateString: string) => {
  const connectDate = new Date(connectDateString)
  const adjustedDate = dayjs(connectDate).add(23, "hour").add(59, "minute").add(59, "second")
  return adjustedDate.toString()
}

// Format the date similar to the Connect style
export const formatDateAsConnect = (date: string) => dayjs(date).format("MMM DD YYYY hh:mm a")

// Format the date similar to the Connect style, do not show time-of-day
export const formatDateOnlyAsConnect = (date: string) => dayjs(date).format("MMM DD YYYY")

// Connect dates are formated as "YYYY-MM-DDTHH:mm:ss.sssZ" TCPS dates are formatted as "YYYY-MM-DD"
export const datesAreEqual = (connectDate: string | undefined, tcpsDate: string | undefined) => {
  // treat blank strings as undefined
  if (connectDate === "") {
    connectDate = undefined
  }
  if (tcpsDate === "") {
    tcpsDate = undefined
  }

  const connectDateString = dayjs(connectDate).format("YYYY-MM-DD")
  const tcpsDateString = dayjs(tcpsDate).format("YYYY-MM-DD")
  return connectDateString === tcpsDateString
}
